import { render, staticRenderFns } from "./SearchByDescription.vue?vue&type=template&id=c3ca8bc4&scoped=true&"
import script from "./SearchByDescription.vue?vue&type=script&lang=js&"
export * from "./SearchByDescription.vue?vue&type=script&lang=js&"
import style0 from "./SearchByDescription.vue?vue&type=style&index=0&id=c3ca8bc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ca8bc4",
  null
  
)

export default component.exports